export default "__VITE_ASSET__eEAgMkl8__"